import { render, staticRenderFns } from "./PersonalChatDrawer.vue?vue&type=template&id=79565456&"
import script from "./PersonalChatDrawer.vue?vue&type=script&lang=js&"
export * from "./PersonalChatDrawer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports